<template>
  <div class="ws-delimiter">
    <div
      class="line"
      :class="lineClass"
    ></div>
    <div
      v-if="text"
      class="text ws-typo-xs"
      :class="textClass"
    >
      {{ $t(text) }}
    </div>
    <div
      v-if="text"
      class="line"
      :class="lineClass"
    ></div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'WsDelimiter',
  props: {
    text: {
      type: String,
      default: ''
    },
    textClass: {
      type: String,
      default: ''
    },
    lineClass: {
      type: String,
      default: ''
    },
  }
});
</script>

<style lang="scss" scoped>
.ws-delimiter {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;

  .line {
    height: 1px;
    min-width: 16px;
    background-color: $delimeter-bg;
    flex: 1 1 auto;
  }

  .text {
    color: $ws-base100;
    margin: 0 map-get($space-md, x);
    flex: 0 1 auto;
  }
}
</style>
